import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
  name: 'counter',
  user:"",
  initialState: {
    auth:false,
    users:[
      // {name:"Bobarajabov Baxrom", number:"+998 (99) 194 08 51", ID:12345690},
      // {name:"Sherzod", number:"+998 (94) 311 98 53", ID:9854321}
    ],
  },
  reducers: {
    increment: (state, action) => {
      const isExist = state?.users?.find((user) => user.number === action.payload.number);
console.log(isExist);
      isExist ? (state.auth = false) : (state.auth = true && state?.users?.push({...action.payload}));
    },

    incrementID: (state, action) => {
      state.user = action.payload
    },

    removeUser:(state, action) => {
      const isExist = state.users?.find((user) => user.number === action.payload.number);

      if (isExist) {
        return state.users?.filter((user) => user.number !== action.payload.number);
      }
    }

  }
});

export const { increment,incrementID,removeUser } = slice.actions;


export const selectCount = state => state.counter.value;

export default slice.reducer;
